import React, { Component } from 'react'
import ScrollToElement from 'scroll-to-element'

import data from '../../_main_data'
const { info } = data

class SlimHeader extends Component {
    generateMenu() {

    }

    theme() {
        switch (this.props.theme) {
            case 'main':
                return 'navbar-dark bg-main-color'
            case 'light':
                return 'navbar-light bg-light-color'
            case 'dark':
            default:
                return 'navbar-dark bg-dark-color'
        }
    }

    logo() {
        const { logo, logo_invert } = info
        switch (this.props.theme) {
            case 'light':
            return logo
            case 'main':
            case 'dark':
            default:
                return logo_invert ? logo_invert : logo
        }
    }

    render() {
        return (
            <nav className={`navbar ${this.theme()}`}>
                <div className="container d-flex flex-md-row flex-column justify-content-between">
                <img src={this.logo()} alt={info.name} style={{ maxHeight: 40 }} />
                        {
                            data.sections.map((section, key) => {
                                if (section.showInMenu === true && section.title) {
                                    return (
                                        <button key={key} className="btn btn-link py-2 d-none d-md-inline-block" onClick={() => { ScrollToElement(`.${section.class}`) }}>{section.title}</button>
                                    )
                                } else { return null }
                            })
                        }
                    </div>
            </nav>
        )
    }
}

export { SlimHeader }


// WEBPACK FOOTER //
// ./src/components/sections/SlimHeader.js